import React from 'react';
import { parseRupiah } from '../../hris/recruitment/utils/formatRupiah';

interface Step2Props {
  formData: any;
  handleChange: (field: string, value: any) => void;
  errors?: Record<string, string>;
}

export default function Step2LoanNeed({ formData, handleChange, errors = {} }: Step2Props) {
  // Format currency untuk input field (menampilkan format bahkan untuk 0)
  const formatCurrencyInput = (value: any): string => {
    if (!value && value !== 0) return '';
    const numValue = typeof value === 'string' ? parseFloat(value.replace(/[^\d]/g, '')) : value;
    if (isNaN(numValue)) return '';
    return new Intl.NumberFormat('id-ID').format(numValue);
  };

  const handleCurrencyChange = (field: string, value: string) => {
    const rawValue = parseRupiah(value);
    if (rawValue === '') {
      handleChange(field, '');
      return;
    }
    const numValue = parseFloat(rawValue);
    handleChange(field, isNaN(numValue) ? '' : rawValue);
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Profil Singkat Calon Debitur
        </label>
        <textarea
          value={formData.debtor_profile}
          onChange={e => handleChange('debtor_profile', e.target.value)}
          rows={4}
          placeholder="Jelaskan profil singkat calon debitur..."
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors duration-200"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Tujuan Pinjaman</label>
        <textarea
          value={formData.loan_purpose}
          onChange={e => handleChange('loan_purpose', e.target.value)}
          rows={3}
          placeholder="Jelaskan tujuan penggunaan pinjaman..."
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors duration-200"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Nominal Dana yang Dibutuhkan (Rp) <span className="text-red-500">*</span>
        </label>
        <div className="relative">
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">Rp</span>
          <input
            type="text"
            value={formatCurrencyInput(formData.requested_amount)}
            onChange={e => handleCurrencyChange('requested_amount', e.target.value)}
            placeholder="0"
            className={`w-full pl-10 pr-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500 transition-colors duration-200 ${
              errors.requested_amount ? 'border-red-500' : 'border-gray-300'
            }`}
          />
        </div>
        {errors.requested_amount && (
          <p className="text-sm text-red-600 mt-1">{errors.requested_amount}</p>
        )}
      </div>
    </div>
  );
}
